// export const BASE_URL = "http://192.168.25.115/admin/Api"
// export const BASE_URL = "https://tabaq.ae/admin/Api"
// export const BASE_URL = "http://localhost:8000/customercare"
 export const BASE_URL = "https://api.tabaq.in/customercare"